import React from "react";
import { DETAILS_DROPPED_FILE_LIST_COLUMN_NAME } from "../../../../../utils/constants/detailsKey";

import Verdict from "../../../Cells/Verdict/Verdict";

import "./styles.scss";

const getLastTwoSegments = (path) => {
  const segments = path.split("/");
  const result = segments.slice(-2).join("/");
  return result;
};

const Details = ({ currentFile }) => {
  return (
    <div className="details-block">
      {DETAILS_DROPPED_FILE_LIST_COLUMN_NAME.map(({ name, accessor }, index) => {
        const rawValue = currentFile[accessor];

        return (
          <div className="details-block__row" key={index}>
            <p className="details-block__row-item">{name}</p>
            {accessor === "verdict" ? (
              <Verdict verdict={rawValue} />
            ) : (
              <p className="details-block__row-item">
                {accessor === "path" && rawValue ? getLastTwoSegments(rawValue) : rawValue || "-"}
              </p>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default Details;
